import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useAuth } from "../Store/AuthContext";
import { ServiceFetchData } from "../APIS/FetchAPIs";

export default function Footer() {
  const { webSetting, RendomTokenfetch } = useAuth();
  const [ServiceData] = ServiceFetchData(RendomTokenfetch);

  return (
    <>
      <footer className="footer-section-2 sectionbg2 fix">
        <div className="container-fluid">
          <div className="footer-widget-wrapper">
            <div className="row">
              <div
                className="col-xxl-4 col-xl-4 col-lg-8 col-md-12 wow fadeInUp"
                data-wow-delay=".2s"
              >
                <div className="footer-widget-items">
                  <div className="widget-head">
                    <Link to="/" aria-label="WebSite Logo">
                      {webSetting.website_logo !== "" ? (
                        <img src={webSetting.website_logo} alt="" />
                      ) : (
                        <img src="../assets/img/logo/logo.png" alt="logo-img" />
                      )}
                    </Link>
                  </div>
                  <div className="footer-content">
                    <p className="text-white">{webSetting.footer_content}</p>
                    <form action="#">
                      <input
                        type="text"
                        name="subemail"
                        id="subemail"
                        placeholder="Email address"
                      />
                      <button className="theme-btn" type="submit">
                        SUBSCRIBE
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              <div
                className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 ps-lg-5 wow fadeInUp"
                data-wow-delay=".4s"
              >
                <div className="footer-widget-items">
                  <div className="widget-head">
                    <h3>Useful Link</h3>
                  </div>
                  <ul className="list-area">
                    <li>
                      <Link to="/about-us">About</Link>
                    </li>
                    {/* <li>
                      <Link to="/our-project">Projects</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/blogs">Blogs</Link>
                    </li> */}
                    <li>
                      <Link to="/careers">Careers</Link>
                    </li>
                    <li>
                      <Link to="/nri-corner">NRI Corner</Link>
                    </li>
                    {/* <li>
                      <Link to="/contact">Contact</Link>
                    </li> */}
                    <li>
                      <Link to="/disclaimer">Disclaimer</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy & Policy</Link>
                    </li>
                    <li>
                      <Link to="/legal-documentation-support">
                        Legal Documentation Support
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="col-xxl-3 col-xl-3 col-lg-5 col-md-4 ps-xl-5 wow fadeInUp"
                data-wow-delay=".8s"
              >
                <div className="footer-widget-items">
                  <div className="widget-head">
                    <h3>Services</h3>
                  </div>
                  <ul className="list-area">
                    {ServiceData.length > 0
                      ? ServiceData.map((serv, index) => (
                          <li key={index}>
                            <Link to={`/service/${serv.slug}`}>
                              {serv.title}
                            </Link>
                          </li>
                        ))
                      : ""}
                  </ul>
                </div>
              </div>
              <div
                className="col-xxl-3 col-xl-3 col-lg-5 col-md-4 ps-lg-5 wow fadeInUp"
                data-wow-delay=".6s"
              >
                <div className="footer-widget-items">
                  <div className="widget-head">
                    <h3>Get In Touch</h3>
                  </div>
                  <ul className="contact-list">
                    <li>
                      <i className="fa-solid fa-location-dot"></i>
                      {webSetting?.address || ""}
                    </li>
                    <li>
                      <i className="fa-solid fa-envelopes"></i>

                      <Link
                        to={`mailto:${
                          webSetting?.email || " info@bhadorva.com"
                        }`}
                        aria-label="Client Email"
                      >
                        {webSetting?.email || " info@bhadorva.com"}
                      </Link>
                    </li>
                    <li>
                      <i className="fa-solid fa-envelopes"></i>
                      <Link
                        to={`mailto:${
                          webSetting?.email2 || " sales@bhadorva.com"
                        }`}
                        aria-label="Client Email"
                      >
                        {webSetting?.email2 || " sales@bhadorva.com"}
                      </Link>
                    </li>

                    <li>
                      <i className="fa-solid fa-phone-xmark"></i>
                      <Link
                        to={`tel:+91${webSetting?.number || " +918308365556"}`}
                        aria-label="Client Contact Number"
                      >
                        +91 {webSetting?.number || " +91 8308365556"}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container-fluid">
            <div className="footer-bottom-wrapper">
              <p className="wow fadeInUp" data-wow-delay=".3sgit">
                {webSetting?.copyright || ""}
              </p>
              <div
                className="social-icon d-flex align-items-center wow fadeInUp"
                data-wow-delay=".5s"
              >
                <Link
                  to={webSetting?.facebook || ""}
                  target="blank"
                  rel="noreferrer"
                  aria-label="Facebook Account"
                >
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link
                  to={webSetting?.instagram || ""}
                  target="blank"
                  className="mx-2"
                  aria-label="Instagram Account"
                >
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link
                  to={webSetting?.youtube || ""}
                  target="blank"
                  aria-label="Youtube Account"
                >
                  <i className="fab fa-youtube"></i>
                </Link>
                <Link
                  to={webSetting?.linkedIn || ""}
                  target="blank"
                  className="ms-2"
                  aria-label="Linkedin Account"
                >
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* <div className="mouseCursor cursor-outer"></div>
      <div className="mouseCursor cursor-inner"></div> */}
      <button
        id="st-back-top"
        className="st-back-to-top show"
        aria-label="back-to-top button"
      >
        <i className="fa-solid fa-arrow-up"></i>
      </button>

      <div className="fixed-tabs-Whats">
        <div className="aba-whatsphone">
          <div className="aba-whatsphone-icone">
            <Link
              target="_blank"
              to={`https://wa.me/+91${
                webSetting?.whatsaap || ""
              }?text=Hi, I would like to speak to a Bhadorva Infra`}
              aria-label="Whatsapp"
            >
              <strong>Whatsapp</strong>
            </Link>
          </div>
        </div>
      </div>

      {/* <div className="fixed-tabs-mag">
        <div className="aba-whatsphone">
          <div className="aba-whatsphone-iconem">
            <Link target="_blank" to="tel:+918308365556">
              <strong>Call Now</strong>
            </Link>
          </div>
        </div>
      </div> */}
    </>
  );
}
